<template>
    <div>
        <InternetAlert />
        <div class="login-container" :class="{ 'login-container--login': $route.name === 'Login' }">
            <div class="slider-section">
                <div class="slider">
                    <div v-for="(slide, index) in slides" :key="index"
                        :class="['slide', { active: currentSlide === index }]"
                        :style="{ backgroundImage: 'url(' + slide.image + ')' }">
                        <div class="slide-overlay">
                            <h2 class="slide-title">{{ slide.title }}</h2>
                            <p class="slide-text">{{ slide.text }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Page content -->
            <div class="login-section">
                
                <slide-y-up-transition mode="out-in" origin="center top">

                    <router-view></router-view>
                </slide-y-up-transition>
            </div>

        </div>
    </div>
</template>

<script>
import {
    SlideYUpTransition
} from 'vue2-transitions'
import InternetAlert from "../views/InternetAlert.vue"
export default {
    name: 'auth-layout',
    components: {
        SlideYUpTransition,
        InternetAlert
    },
    data() {
        return {
            year: new Date().getFullYear(),
            showMenu: false,
            currentSlide: 0,
            slides: [
                {
                    image: '/img/slider/schooldock-banner.jpg?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
                    title: 'Comprehensive School Management',
                    text: 'SchoolDock brings Teacher, Students and Parents together on one platform to simplify management and improve outcomes.'
                },
                
            ],
        }
    },
    methods: {
        nextSlide() {
            this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        },
    },
    mounted() {
        // Auto-advance slides every 5 seconds
        setInterval(this.nextSlide, 5000);
    }
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

body {
    background-color: #f5f7fa;
    height: 100vh;
    overflow: hidden;
}

.login-container {
    display: flex;
    width: 100%;
    height: 100vh;
    background: white;
    overflow: hidden;
}

.slider-section {
    flex: 3;
    /* Takes 3/4 of the width */
    position: relative;
    overflow: hidden;
}

.slider {
    width: 100%;
    height: 100%;
    position: relative;
}

.slide {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 1s ease-in-out;
    background-size: cover;
    background-position: center;
}

.slide.active {
    opacity: 1;
}

.slide-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 40px;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
    color: white;
}

.slide-title {
    font-size: 32px;
    font-weight: 600;
    margin-bottom: 15px;
}

.slide-text {
    font-size: 18px;
    line-height: 1.6;
    max-width: 600px;
}

.login-section {
    flex: 1;
    /* Takes 1/4 of the width */
    padding: 60px 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: white;
    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.05);
}

/* The login form can grow beyond short landscape viewports when feedback appears. */
.login-container--login {
    min-height: 100vh;
    height: auto;
    overflow: visible;
}

.login-container--login .login-section {
    min-height: 100vh;
    height: auto;
}


.divider {
    display: flex;
    align-items: center;
    margin: 25px 0;
}

.divider::before,
.divider::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #ddd;
}

.divider span {
    padding: 0 15px;
    color: #777;
    font-size: 14px;
}

.social-login {
    display: flex;
    gap: 15px;
    margin-bottom: 25px;
}

.social-btn {
    flex: 1;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: white;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease;
}

.social-btn:hover {
    background: #f5f7fa;
    transform: translateY(-2px);
}

.social-btn i {
    font-size: 18px;
}

.google-btn {
    color: #DB4437;
}

.facebook-btn {
    color: #4267B2;
}

.signup-link {
    text-align: center;
    margin-top: 30px;
    color: #777;
}

.signup-link a {
    color: #6a11cb;
    text-decoration: none;
    font-weight: 500;
}

.signup-link a:hover {
    text-decoration: underline;
}

@media (max-width: 1024px) {
    .slider-section {
        flex: 2;
        /* Adjust ratio for medium screens */
    }

    .login-section {
        flex: 1;
    }
}

@media (max-width: 768px) {
    .login-container {
        flex-direction: column;
    }

    .slider-section {
        display: none;
        /* Hide slider on mobile */
    }

    .login-section {
        flex: 1;
        min-height: 100vh;
        padding: 32px 24px;
        width: 100%;
    }
}

@media (max-width: 768px) and (max-height: 520px) {
    .login-container--login .login-section {
        min-height: 100vh;
        padding-top: 24px;
        padding-bottom: 24px;
    }
}

@media (min-width: 769px) {
    .slider-section {
        display: block;
        /* Show slider on desktop */
    }
}


</style>
